import { makeAutoObservable } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import { AnalyticsPath, BillingPath } from 'entities/ExportRouters'
import { BuyCreditsModalStore } from 'entities/Billing/ui/BuyCreditsModal'
import { AutoRechargeWidgetStore } from 'entities/Billing/ui/AutoRechargeModal'
import { type SubscriptionStore } from 'entities/Subscription'
import { type OrganizationStore } from 'entities/Organization'
import { type BillingStore } from 'entities/Billing'

export class CreditsInfoStore {
  private _subscriptionStore: SubscriptionStore
  private _buyCreditsModalStore: BuyCreditsModalStore
  private _autoRechargeWidgetStore: AutoRechargeWidgetStore

  constructor(
    subscriptionStore: SubscriptionStore,
    organizationStore: OrganizationStore,
    billingStore: BillingStore
  ) {
    this._subscriptionStore = subscriptionStore
    this._buyCreditsModalStore = new BuyCreditsModalStore(
      subscriptionStore,
      organizationStore,
      billingStore
    )
    this._autoRechargeWidgetStore = new AutoRechargeWidgetStore(billingStore, subscriptionStore)

    makeAutoObservable(this)
  }

  get autoRechargeWidgetStore() {
    return this._autoRechargeWidgetStore
  }

  onCreditUsageClick = () => {
    uiStore.changeRoute({
      path: `/${AnalyticsPath.creditUsage}`,
    })
  }

  onBuyCreditsClick = () => {
    if (this._subscriptionStore.isTrial) {
      uiStore.changeRouteViaVue({
        path: `/${BillingPath.upgrade}`,
      })
      return
    }

    this._buyCreditsModalStore.openModal()
  }

  onAutoRechargeSwitchChange = () => {
    if (this._subscriptionStore.isTrial) {
      uiStore.changeRouteViaVue({
        path: `/${BillingPath.upgrade}`,
      })
      return true
    }
  }

  onAutoRechargeEditThresholdClick = () => {
    if (this._subscriptionStore.isTrial) {
      uiStore.changeRouteViaVue({
        path: `/${BillingPath.upgrade}`,
      })
      return true
    }
  }
}
